import {Injectable} from '@angular/core';
import {Router} from '@angular/router';
import {faShip} from '@fortawesome/free-solid-svg-icons';
import {ShippingLineService} from 'app/blocks/service/api/shipping-line.service';
import {Resource} from 'app/constants/resource';
import {ENTITIES_SETUP_BASE_URL} from 'app/app.constants';
import {EntityNavigator} from 'app/blocks/routing/navigator';
import {EntityUrlProvider} from 'app/blocks/routing/entity-url-provider';
import {AbstractEntityResource} from 'app/blocks/resource/abstract-entity-resource';
import {IShippingLine, ShippingLine} from 'app/blocks/model/shipping-line.model';

@Injectable({
    providedIn: 'root'
})
export class ShippingLineResource extends AbstractEntityResource<IShippingLine> {
    constructor(shippingLineService: ShippingLineService, router: Router) {
        super(
            Resource.SHIPPING_LINES,
            shippingLineService,
            new EntityNavigator(ENTITIES_SETUP_BASE_URL, Resource.SHIPPING_LINES, router),
            new EntityUrlProvider(ENTITIES_SETUP_BASE_URL, Resource.SHIPPING_LINES),
            (entity?) => new ShippingLine(entity),
            (entity) => entity.id,
            faShip
        );
    }
}
